export default __webpack_public_path__ + "static/media/IPutuSubawa.20f0b7e8.png";